module.exports = __webpack_public_path__ + "img/LA.4292ecbc.png";